module.exports = __webpack_public_path__ + "static/img/ico_notice.ce72bb1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/promotion/PR010102/ico_notice.png
// module id = S2Qs
// module chunks = 10